import CustomerDataContainer from "./CustomerDataContainer";
import CustomerDataStore from "./CustomerDataStore";

export default CustomerDataStore(CustomerDataContainer); 